import { ReactElement, ReactNode } from 'react';

// Height reserved in the x-axis band for the SVG label so it sits below the ticks instead of
// intersecting them. Callers add this to their `useDynamicYAxisWidth` xAxisHeightModifier (sat
// charts) or to the XAxis `height` directly (LineChart).
export const X_AXIS_LABEL_HEIGHT = 16;

// Shared factory for a centered x-axis label, rendered as SVG <text> at the bottom of the reserved
// x-axis band so it lands under the ticks rather than the recharts default (which rides onto them).
// Styled via the `.sat-chart-x-axis-label` rule (the `satXAxisLabel` mixin for sat charts, a matching
// rule in LineChart.scss). Pass as `<XAxis label={renderXAxisLabel(text)} />`.
export const renderXAxisLabel = (label: ReactNode) =>
  function XAxisLabel({
    viewBox: { x, y, width, height }
  }: {
    viewBox: { x: number; y: number; width: number; height: number };
  }): ReactElement {
    return (
      <text x={x + width / 2} y={y + height} textAnchor='middle' className='sat-chart-x-axis-label'>
        {label}
      </text>
    );
  };
